import React from 'react';
import { Section } from '../fields';
import { asArray } from '../listOps';
import { Bubble, BubbleList } from './BubbleList';
import { CardEditorProps } from './types';

const StepChatEditor: React.FC<CardEditorProps> = ({ card, onChange }) => (
  <Section title="Messages" help="Played in order. Leave the delay empty for automatic spacing.">
    <div className="lbe-chat">
      <BubbleList
        items={asArray<Bubble>(card.messages)}
        speakers="pick"
        delay="optional"
        herAvatar={card.characterInitial || undefined}
        onChange={(messages) => onChange({ ...card, messages })}
      />
    </div>
  </Section>
);

export default StepChatEditor;
